import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'
import type { FraudDecision, FraudStatus } from '@/types/Activity'

const fraudStatusMutation = gql`
  mutation fraudStatus(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $fraudStatus: FraudStatus!
    $reason: String!
    $fraudDecision: FraudDecision
  ) {
    fraudStatus(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      fraudStatus: $fraudStatus
      reason: $reason
      fraudDecision: $fraudDecision
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  fraudStatus: FraudStatus
  reason: string
  fraudDecision?: FraudDecision
}

export type FraudStatusData = {
  fraudStatusData: string | unknown
}

export const useFraudStatusMutation: WrappedMutation<
  FraudStatusData,
  MutationVars
> = () =>
  useMutation<FraudStatusData, MutationVars>(fraudStatusMutation, {
    client: agentClient,
  })
